module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"student":"邀约对象"},"TW":{"student":"邀約對象"},"en":{"student":"Invited Student"}}')
  delete Component.options._Ctor
}
